module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "insight-item"
  }, [_c('div', {
    staticClass: "unit-head"
  }, [_c('el-popover', {
    attrs: {
      "content": _vm.description,
      "width": "250",
      "placement": "bottom-end",
      "trigger": "hover"
    }
  }, [_c('h5', {
    staticClass: "unit-title",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v(_vm._s(_vm.title))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(Math.round(_vm.value).toLocaleString()))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3df7e4d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/social/facebook/PostInsightItem.vue
// module id = 3236
// module chunks = 3